import { Component, OnInit, Inject } from '@angular/core';
import { Dictionary } from 'models';
import { Page } from '_interfaces/page';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Role } from 'enums';

export interface VendorEditArgs {
  vendor: Dictionary;
}

@Component({
  selector: 'app-vendor-edit-dialog',
  templateUrl: './vendor-edit-dialog.component.html',
  styleUrls: ['./vendor-edit-dialog.component.scss'],
  standalone: false
})
export class VendorEditDialogComponent implements OnInit, Page {
  // page
  pageTitle = 'Edit vendor';
  pageDescription = 'edit data below to update vendor';

  // other properties
  vendor: Dictionary;
  isValid = false;
  Role = Role;

  constructor(
    public dialogRef: MatDialogRef<VendorEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: VendorEditArgs) {
  }

  ngOnInit() {
    this.vendor = {
      ...this.data.vendor
    };
  }

  onSaveClick(): void {
    if (this.isValid) {
      this.dialogRef.close(this.vendor);
    }
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  isValidChanged(isValid: boolean) {
    this.isValid = isValid;
  }
}
